import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {TranslateService} from "@ngx-translate/core";
import {UserStore} from "@vision-inspection/user";
import {IconRegistry} from "./_services/icon-registry.service";
import {UserPermissionStore} from "@vision-inspection/shared";

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent {
  private translate: TranslateService = inject(TranslateService);
  private userStore = inject(UserStore); // eslint-disable-line
  private userPermissionStore: UserPermissionStore = inject(UserPermissionStore); // eslint-disable-line
  private iconRegistry: IconRegistry = inject(IconRegistry);

  public constructor() {
    this.translate.addLangs(['de', 'en']);
    this.translate.setFallbackLang('en');
    this.translate.use('en');

    this.iconRegistry.registerIconSet("app", "trumpf-icons", "svg");

    this.userStore.loadUserInfo(this.translate.getCurrentLang());
  }
}
